import { component } from 'picoapp';
import { addVariant } from '../../../js/lib/cart';
import Drawer from '../../../js/utils/drawer';

export default component(async (node) => {
  /**
   * Data + elements
   */
  const price = node.querySelector('.js-price');
  const selectedDenomination = node.querySelector('.js-selectedDenomination');
  const denominationSelectionBtn = node.querySelector('.js-denominationSelectionBtn');
  const denominationDrawerElement = node.querySelector('.js-denominationDrawer');
  const denominationValueBtns = node.querySelectorAll('.js-denominationValueBtn');
  const denominationDrawerCloseBtn = node.querySelector('.js-denominationDrawerCloseBtn');
  const form = node.querySelector('.js-form');
  const variantSelect = node.querySelector('.js-variantSelect');
  const addToCartBtn = node.querySelector('.js-addToCartBtn');

  const productData = JSON.parse(node.querySelector('.js-productData').innerHTML);

  const config = JSON.parse(node.dataset.config);
  const { denominationOptionPosition } = config;

  /**
   * Functions
   */
  const initVariantSelection = () => {
    const selectedVariantCallback = (variant) => {
      price.textContent = Shopify.formatMoney(variant.price, theme.moneyFormat);
    };

    const createShopifySelection = () => new Shopify.OptionSelectors(`product-${productData.id}`, {
      product: productData,
      onVariantSelected: selectedVariantCallback,
      enableHistoryState: true,
    });

    createShopifySelection();
  };

  const initOptionSelection = () => {
    const denominationDrawer = Drawer(denominationDrawerElement);

    denominationSelectionBtn.addEventListener('click', () => denominationDrawer.open());
    denominationDrawerCloseBtn.addEventListener('click', () => denominationDrawer.close());

    const trueOptionSelectors = node.querySelectorAll('.single-option-selector');
    const trueDenominationSelector = Array.from(trueOptionSelectors).find((selector) => parseInt(selector.dataset.option.replace('option', ''), 10) === denominationOptionPosition);

    const selectDenomination = (btn) => {
      const { value } = btn.dataset;

      selectedDenomination.textContent = value;
      selectedDenomination.dataset.value = value;

      trueDenominationSelector.value = selectedDenomination.dataset.value;

      trueOptionSelectors.forEach((selector) => selector.dispatchEvent(new Event('change')));

      addToCartBtn.disabled = false;

      denominationDrawer.close();
    };

    denominationValueBtns.forEach((btn) => {
      btn.addEventListener('click', () => selectDenomination(btn));
    });

    const updateSelectionFromVariantParam = () => {
      const params = new URLSearchParams(window.location.search);
      const variantParam = parseInt(params.get('variant'), 10);

      if (variantParam) {
        const variant = productData.variants.find((v) => v.id === variantParam);
        const denomination = variant[`option${denominationOptionPosition}`];

        const matchingDenominationValueBtn = Array.from(denominationValueBtns).find((btn) => btn.dataset.value === denomination);; // eslint-disable-line
        matchingDenominationValueBtn.click();
      }
    };

    updateSelectionFromVariantParam();
  };

  const initForm = () => {
    const toggleButton = (active) => {
      addToCartBtn.classList[active ? 'remove' : 'add']('animate-pulse');
      addToCartBtn.querySelector('.icon').style.display = active ? '' : 'none';
      addToCartBtn.querySelector('.load-ring').style.display = !active ? '' : 'none';
    };

    form.addEventListener('submit', (event) => {
      event.preventDefault();

      toggleButton(false);

      const variantId = variantSelect.value;

      addVariant({
        variantId,
        quantity: 1,
        callback: () => toggleButton(true),
      });
    });
  };

  const init = () => {
    initVariantSelection();
    initOptionSelection();
    initForm();
  };

  /**
   * Init
   */
  init();
});
